import { Outlet } from 'react-router-dom';
import styles from './AuthLayout.module.css';
import { LoginFooter } from '@/features/auth/components/LoginFooter';

export default function AuthLayout() {
  return (
    <div className={styles.layout}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <img src="/logo_delta.svg" alt="delt.ai" width={64} height={64} />
        </div>
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>

      <LoginFooter />
    </div>
  );
}

export { AuthLayout };
